import styled from "react-emotion";

const H1 = styled("h1")`
  color: #2f3241;
  font-size: 30px;
  margin-left: 10px;
  margin-top: 20px;
  margin-bottom: 5px;
  font-weight: 700;
`;

const H2 = styled("h2")`
  color: #2f3241;
  margin-top: 10px;
  font-size: 20px;
  margin-left: 10px;
  font-weight: 700;
`;

const H3 = styled("h3")`
  color: #2f3241;
  font-size: 15px;
  margin-left: 10px;
  font-weight: 700;
`;

export { H1, H2, H3 };



// WEBPACK FOOTER //
// ./src/elements/Heading.tsx